import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tonoMuscular: [],
  },

  getters: {
    getTonoMuscular: (state) => state.tonoMuscular,
  },

  mutations: {
    SET_TONO_MUSCULAR(state, tonoMuscular) {
      state.tonoMuscular = tonoMuscular;
    },
  },

  actions: {
    async fetchTonoMuscular({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTonoMuscular')
        .then((response) => {
          commit('SET_TONO_MUSCULAR', response.data.data);
        });
    },
  },
};
